// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"832":"c69c05ecb2108118992e","997":"daed014151af0c4f0167"}[chunkId] + ".js";
};